import React from 'react'
import { Link, Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24ArrowRight24 } from '@is24/cosma-ui-icons'

type FairPriceNotificationProps = {
  minValue: number
  maxValue: number
  onOpenDetails: () => void
}

export function FairPriceNotification({ minValue, maxValue, onOpenDetails }: FairPriceNotificationProps) {
  const { t, i18n } = useTranslation()

  return (
    <Notification
      type='success'
      size='medium'
      variant='flat'
      title=''
      message={t('wizard.screen.basicInfo.price.recommendedNotification.success', {
        minValue: minValue.toLocaleString(i18n.language),
        maxValue: maxValue.toLocaleString(i18n.language),
      })}
      actionButton={
        <Link onClick={onOpenDetails} rightIcon={<IconS24ArrowRight24 />}>
          {t('wizard.screen.basicInfo.price.recommendedNotification.actionButton')}
        </Link>
      }
    />
  )
}
